import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useIsAuthenticated } from '@/hooks/redux';
// import { ThemeSwitcher } from '@/components/common/ThemeSwitcher';

export function AuthLayout() {
  // const isAuthenticated = useIsAuthenticated();
  // const transactionCode = localStorage.getItem('transactionCode');

  // Redirect to dashboard if already authenticated
  // if (isAuthenticated && transactionCode) {
  //   return <Navigate to="/transaction-code" replace />;
  // } else if (isAuthenticated && !transactionCode) {
  //   return <Navigate to="/dashboard" replace />;
  // }

  return (
    <div className="min-h-screen overflow-hidden bg-[#050505] text-white">
      <div className="absolute inset-0 overflow-hidden">
        <div className="surf-orb surf-orb-one" />
        <div className="surf-orb surf-orb-two" />
        <div className="surf-wave surf-wave-one" />
        <div className="surf-wave surf-wave-two" />
        <div className="surf-grid" />
      </div>

      <div className="relative z-10 flex min-h-screen items-center justify-center p-4 sm:p-6">
        <div className="relative w-full max-w-[560px]">
          <div className="absolute inset-0 -z-10 rounded-[32px] bg-primary/10 blur-3xl" />
          <div className="rounded-[28px] border border-white/10 bg-white/5 p-1 shadow-[0_25px_80px_-30px_rgba(255,184,12,0.45)] backdrop-blur-xl">
            <div className="rounded-[24px] bg-[linear-gradient(145deg,rgba(255,255,255,0.08),rgba(0,0,0,0.72))] p-5 sm:p-8">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
